import * as React from "react";
import { View, Text, Image, ScrollView, StyleSheet } from "react-native";

import { colors, shadow } from "../../theme/modern";

// Centered card used by the login screens
const AuthCardComponent = ({ title, subtitle, children, footer }) => (
  <ScrollView
    style={styles.screen}
    contentContainerStyle={styles.content}
    keyboardShouldPersistTaps="handled"
  >
    <View style={styles.card}>
      <Image
        resizeMode="contain"
        style={styles.logo}
        source={{ uri: "whole_text_logo" }}
      />
      <Text style={styles.title}>{title}</Text>
      {subtitle ? <Text style={styles.subtitle}>{subtitle}</Text> : null}
      <View style={styles.body}>{children}</View>
    </View>
    {footer}
  </ScrollView>
);

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: colors.background,
  },
  content: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 32,
    paddingHorizontal: 16,
  },
  card: {
    width: "100%",
    maxWidth: 400,
    paddingHorizontal: 32,
    paddingTop: 32,
    paddingBottom: 28,
    borderRadius: 20,
    alignItems: "center",
    backgroundColor: colors.surface,
    ...shadow.raised,
  },
  logo: {
    width: 210,
    height: 66,
    marginBottom: 14,
  },
  title: {
    fontSize: 22,
    fontWeight: "700",
    color: colors.text,
    textAlign: "center",
  },
  subtitle: {
    marginTop: 6,
    fontSize: 14,
    lineHeight: 20,
    color: colors.textMuted,
    textAlign: "center",
  },
  body: {
    width: "100%",
    marginTop: 22,
  },
});

export default AuthCardComponent;
